import { token } from '@atlaskit/tokens';

export const getBackground = () => token('elevation.surface', '#FFFFFF');
